export const tableUpdateWarning =
  'Changing the data type of a column might cause some issues so recheck with the table data to see what is the correct datatype.';
export const analyticsMainUrl = 'https://erp.supista.com/analytics';
